import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { ThemeProvider } from "../components/theme/ThemeProvider";
import { CssBaseline } from "@material-ui/core";
import { Home } from "../pages/Home";
import NotFoundPage from "../pages/NotFoundPage";
import { PrivacyPolicyPage } from "../pages/PrivacyPolicyPage";
import { LegalPage } from "../pages/LegalPage";

export const App = () => {
  return (
    <ThemeProvider>
      <CssBaseline />
      <Router>
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/privacy-policy" exact component={PrivacyPolicyPage} />
          <Route path="/legal" exact component={LegalPage} />
          <Route path="*" component={NotFoundPage} />
        </Switch>
      </Router>
    </ThemeProvider>
  );
};
